<template>
    <div>
        <div class="d-flex justify-content-end">
            <b-button
                class="align-baseline mr-1"
                title="Edit"
                variant="default"
                @click="showEditModal"
            >
                <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
            </b-button>
            <b-button
                class="align-baseline"
                title="Delete"
                variant="default"
                @click="showDeleteModal"
            >
                <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
            </b-button>
        </div>
        <modal
            :id="deleteModalId"
            title="Delete lockout"
            ok-title="Confirm"
            @ok="deleteLockout"
        >
            Are you sure you want to delete this lockout?
        </modal>
        <modal
            :id="editModalId"
            :title="'Edit Lockout'"
            dialog-class="create-lockout-modal"
            ok-title="Save"
            :scrollable="false"
            :ok-disabled="disabledUpdate"
            @ok.prevent="updateLockout"
        >
            <div class="source-wrapper">
                <span> When making a reservation for: </span>
                <form-select
                    class="mt-2 mb-4 w-100"
                    :disabled="true"
                    :options="options"
                    :value="selectedSource"
                />
                <span>
                    ... lockout the property (or roomtypes) selected below
                </span>
            </div>
            <div class="d-flex flex-column">
                <span class="mb-2 mt-2 text-center"
                    >List Properties / Roomtypes</span
                >
                <lockout-property-select
                    :initial-value="initialValues"
                    :properties="destinationOptions"
                    v-model="selectedDestinations"
                    placeholder="Properties"
                    class="d-flex w-100"
                ></lockout-property-select>
            </div>
        </modal>
    </div>
</template>

<script>
import Modal from '../../generic/modal/modal.vue';
import FormSelect from '../../generic/form-select/form-select.vue';
import FormInput from '../../generic/form-input/form-input.vue';
import LockoutPropertySelect from './lockouts-property-select.vue';
import { mapActions, mapGetters } from 'vuex';
import API from '../../../api';
import {
    PROPERTY_LOCKOUT_RETRIEVE_ENDPOINT,
} from '../../../endpoints';

export default {
    components: {
        Modal,
        FormSelect,
        FormInput,
        LockoutPropertySelect,
    },
    data() {
        return {
            selectedSource: null,
            search: null,
            selectedDestinations: [],
            initialValues: [],
            options: [],
        };
    },
    computed: {
        ...mapGetters('propertyLockout', ['destinationItems']),
        editModalId() {
            return 'edit-modal' + this.params.data.id;
        },
        deleteModalId() {
            return 'delete-modal' + this.params.data.id;
        },
        disabledUpdate() {
            return !this.selectedDestinations.length;
        },
        destinationOptions() {
            return this.destinationItems.filter(
                (item) => item.value !== this.selectedSource
            );
        },
    },
    watch: {
        initialValues(value) {
            this.selectedDestinations = this.initialValues.map(
                (item) => item.value
            );
        },
    },
    methods: {
        ...mapActions('propertyLockout', [
            'retrieveLockoutData',
            'removeLockout',
            'editLockout',
            'fetchDestinationItems',
        ]),
        showDeleteModal() {
            this.$bvModal.show(this.deleteModalId);
        },
        async showEditModal() {
            await this.retrieveLockout();
            this.$bvModal.show(this.editModalId);
        },
        async deleteLockout() {
            try {
                this.busy = true;
                await this.removeLockout(this.params.data.id);
                this.params.refresh();
            } catch (e) {
                this.errorToast({text: 'Could not delete lockout.'})
            } finally {
                this.busy = false;
            }
        },
        async retrieveLockout() {
            try {
                this.fetchDestinationItems();
                const { data } = await API.get(
                    PROPERTY_LOCKOUT_RETRIEVE_ENDPOINT(this.params.data.id)
                );
                this.options.push({
                    value: data.rental_property.id,
                    text: data.rental_property.name,
                });

                this.initialValues = data.property_lockout_destination.map(
                    (property) => {
                        return {
                            value: property.rental_property.id,
                            text: property.rental_property.name,
                        };
                    }
                );
                this.selectedSource = this.options[0].value;
            } catch (e) {
                this.errorToast({text: 'Could not load data.'})
            }
        },
        async updateLockout() {
            try {
                this.busy = true;
                await this.editLockout({
                    id: this.params.data.id,
                    destination_lockouts: this.selectedDestinations,
                    source_property_room: this.selectedSource,
                });
                this.$bvModal.hide(this.editModalId);
                this.params.refresh();
            } catch (e) {
                this.errorToast({text: 'Could not update property lockout.'})
            } finally {
                this.busy = false;
            }
        },
    },
};
</script>
